import { DefiGroup } from "../../Services/Setting/SettingService";
import { BoxCard } from "./BoxCard";
interface Progress {
    current: number;
    total: number;
    label?: string;
}

interface Box {
    url: string;
    image: string;
    title: string;
    description: string;
    points: string;
    key?: string;
    progress?: Progress;
    is_translate?: string;
}

interface Props2 {
    box: Box;
    defis: DefiGroup[];
    translate: (namespace: string, key: string, params?: any) => string;
    status?: string;
}

export const BoxItem = ({ box, defis, translate, status }: Props2) => {
    const filteredData = defis.find((item) => item?.key === box.key);
    if (!filteredData) return null;

    if (status === "completed") {
        return (
            <>
                {filteredData.completed.map((completed, index) => (
                    <BoxCard
                        key={index}
                        url={box.url}
                        image={box.image}
                        title={box.title}
                        description={box.description}
                        isTranslate={box.is_translate}
                        progress={box.progress as Progress}
                        current={completed.count}
                        total={completed.total}
                        points={completed.point}
                        translate={translate}
                    />
                ))}
            </>
        );
    }
    const progress = filteredData.inProgress?.count ?? 0;
    const total = filteredData.inProgress?.total ?? 0;
    const points = filteredData.inProgress?.point ?? Number(box.points);

    return (
        <BoxCard
            url={box.url}
            image={box.image}
            title={box.title}
            description={box.description}
            isTranslate={box.is_translate}
            progress={box.progress}
            current={progress}
            total={total}
            points={points}
            translate={translate}
        />
    );
};
